// extracted by mini-css-extract-plugin
export default {"sorting__chart":"SortingChart_sorting__chart__DjB0+","bars":"SortingChart_bars__eeADw"};